<template lang="pug">
  div
    v-card
      v-card-text.pa-0
        v-list-item
          v-list-item-content
            v-list-item-title
              strong Amount Receivable:
            v-list-item-title(v-if='getBalance()>0') Balance
          v-list-item-action
            v-list-item-action-text
              | &#x20B9;{{amount}}
              v-icon(color='green' small='' v-if='getBalance()<=0') mdi-check-outline
            v-list-item-action-text(v-if='getBalance()>0')
              | &#x20B9;{{getBalance()}}
              v-icon(color='red' small='') mdi-exclamation
        v-divider
        v-list-item(v-if='payments.length') Payments Received:
        v-divider
        v-list-item(v-for='(p,idx) in payments' :key='idx')
          v-list-item-content
            v-list-item-title
              | {{p.type}}
              span(v-if='p.reference') (Ref: {{p.reference}})
          v-list-item-action
            v-list-item-action-text
              | &#x20B9;{{parseFloat(p.amount).toFixed(2)}}
              v-icon(small='' @click='vibrate();deletePayment(idx)') mdi-delete
        v-divider
        v-list-item(v-if='getBalance()<0')
          v-list-item-content
            v-list-item-title Pay Back:
          v-list-item-action
            v-list-item-action-text
              | &#x20B9;{{getBalance()}}
              v-icon(color='red' small='') mdi-exclamation
        v-divider
      v-card-text(v-if='getBalance()>0')
        | Add payment:
        v-container.pa-0
          v-row(no-gutters)
            v-col(cols='4')
              v-select(v-model='editedItem.type' :items='paymentTypes' label='Payment Type:')
            v-spacer
            v-col(cols='1')
              v-text-field(v-if="editedItem.type=='Discount'" v-model='discount' label='%')
            v-spacer
            v-col(cols='4')
              v-text-field(clearable='' v-model='editedItem.amount' label='Balance:')
          v-row(no-gutters)
            v-col(cols='8')
              v-text-field(v-model='editedItem.reference' label='Reference')
            v-spacer
            v-col(cols='3')
              v-btn(color='primary' text='' v-on:click.stop='vibrate();add()') Add

</template>
<script>
export default {
  name: "ezpayment",
  props: { payments: Array, amount: String },
  beforeMount() {
    Object.assign(this.editedItem, this.defaultItem);
  },
  data() {
    return {
      paymentTypes: [
        "Cash",
        "PayTM",
        "BHIM",
        "Visa",
        "Master",
        "Rupay",
        "Discount"
      ],
      paymentType: "Cash",
      editedItem: {},
      discount: 0,
      defaultItem: {
        type: "Cash",
        amount: this.getBalance(),
        reference: ""
      }
    };
  },
  methods: {
    getBalance() {
      let pd = 0;
      this.payments.forEach(p => (pd += Number(p.amount)));
      return parseFloat(Number(this.amount) - pd).toFixed(2);
    },
    add() {
      if (Number(this.editedItem.amount)) {
        const newPay = Object.assign({}, this.editedItem);
        this.payments.push(newPay);
        this.editedItem.amount = this.getBalance();
        this.$forceUpdate();
        this.$emit("updated");
      }
    },
    deletePayment(idx) {
      this.payments.splice(idx, 1);
      this.editedItem.amount = this.getBalance();
      this.$forceUpdate();
      this.$emit("updated");
    }
  }
};
</script>
